import ReducerCreator from '../registerReducer';
import * as CONST from './userGroups.constants';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';
import { UserGroups } from '../../models';
import { copy, StoreItem } from '../Store';
import { buildStoreItem } from '../storeItemBuilder';

const r = new ReducerCreator<UserGroups>()
    .register<UserGroups[]>(APPLICATION_DISCONNECTED, () => {
        return new StoreItem<UserGroups>();
    })
    .register<UserGroups[]>(CONST.USER_GROUPS_LOAD, () => {
        const newItem = new StoreItem<UserGroups>();
        newItem.isLoading = true;
        return newItem;
    })
    .register<UserGroups[]>(CONST.USER_GROUPS_LOAD_SUCCESS, (state, payload) => {
        return buildStoreItem(payload);
    })
    .register<UserGroups>(CONST.USER_GROUPS_UPDATE_SUCCESS, (state, payload) => {
        const newItem = copy(state);
        const dictionary = Object.assign({}, newItem.dictionary);
        dictionary[payload.guid] = payload;
        newItem.isLoaded = true;
        newItem.isLoading = false;
        newItem.dictionary = dictionary;
        return newItem;
    })
    .register<UserGroups>(CONST.USER_GROUPS_DELETE_SUCCESS, (state, payload) => {
        const newItem = copy(state);
        const dictionary = Object.assign({}, newItem.dictionary);
        delete dictionary[payload.guid];
        newItem.isLoaded = true;
        newItem.isLoading = false;
        newItem.dictionary = dictionary;
        return newItem;
    })
    .register<UserGroups>(CONST.USER_GROUPS_DELETE_ERROR, (state, payload) => {
        const newItem = copy(state);
        const dictionary = Object.assign({}, newItem.dictionary);
        delete dictionary[payload.guid];
        newItem.isLoaded = true;
        newItem.isLoading = false;
        newItem.error = payload;
        newItem.hasError= true;
        newItem.dictionary = dictionary;
        return newItem;
    });

export function userGroupsReducer(
    state: StoreItem<UserGroups> = new StoreItem<UserGroups>(),
    action: { type: string; payload: any }
) {
    return r.reduce(state, action);
}
